// import { SignIn } from "@/app/api/auth/route";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  user: any | null;
  role: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  token: null,
  user: null,
  role: null,
  loading: false,
  error: null,
};

export const loginThunk = createAsyncThunk(
  "auth/login",
  async (loginData: { mobileNo: string; password: string }, { rejectWithValue }) => {
    try {
      const { SignIn } = await import("@/app/api/auth/route");
      const response = await SignIn(loginData);
      if (!response?.data?.status) {
        return rejectWithValue(response?.data?.errors?.[0] || "Login failed");
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.message || "Something went wrong");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.role = null;
    },

    setAuthUser: (state, action) => {
      state.user = action.payload;
      state.role = action.payload?.role?.name ?? state.role;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.accessToken;
        state.user = action.payload.user;
        state.role = action.payload.user?.role?.name;
      })
      .addCase(loginThunk.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, setAuthUser } = authSlice.actions;
export default authSlice.reducer;
